import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const pomreceipeApi = api
  .enhanceEndpoints({ addTagTypes: ['POMReceipe'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOMReceipes: builder.query<po_mreceipe[], string>({
        query: cid => `pomreceipe/${cid}`,
        providesTags: ['POMReceipe']
      }),
      getPOMReceipeByTable: builder.query<any[], any>({
        query: ({ cid, tbl }) => `pomreceipe/bytbl/${cid}/${tbl}`,
        providesTags: ['POMReceipe']
      }),
      getPOMReceipeById: builder.query<po_mreceipe, string>({
        query: id => `pomreceipe/byid/${id}`,
        providesTags: ['POMReceipe']
      }),
      insertPOMReceipe: builder.mutation({
        query: POMReceipe => ({
          url: `pomreceipe/`,
          method: 'POST',
          body: POMReceipe
        }),
        invalidatesTags: ['POMReceipe']
      }),
      updatePOMReceipe: builder.mutation({
        query: POMReceipe => ({
          url: `pomreceipe/`,
          method: 'PUT',
          body: POMReceipe
        }),
        invalidatesTags: ['POMReceipe']
      }),
      deletePOMReceipe: builder.mutation({
        query: POMReceipe => ({
          url: `pomreceipe/${POMReceipe.on_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POMReceipe']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOMReceipesQuery,
  useGetPOMReceipeByTableQuery,
  useGetPOMReceipeByIdQuery,
  useInsertPOMReceipeMutation,
  useUpdatePOMReceipeMutation,
  useDeletePOMReceipeMutation
} = pomreceipeApi;

